<div class="modal-header">
    <h4 class="modal-title">Subir archivos</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>
<div class="modal-body">
    <div class="row" *ngIf="limite != null">
        <p>Límite de archivos: <b>{{limite}}</b></p>
    </div>
    <ngx-dropzone (change)="onSelect($event)">
        <ngx-dropzone-label>Arrastrar y soltar</ngx-dropzone-label>
        <ngx-dropzone-preview *ngFor="let f of files" [removable]="true" (removed)="onRemove(f)">
            <ngx-dropzone-label>{{ f.name }} ({{ f.type }})</ngx-dropzone-label>
        </ngx-dropzone-preview>
    </ngx-dropzone>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="cancelar()">Cancelar</button>
    <button type="button" class="btn btn-success" (click)="confirmar()">Confirmar</button>
</div>